(function () {
  'use strict';

  var script = document.currentScript;
  if (!script) return;

  var dataEl = script.previousElementSibling;
  if (!dataEl || dataEl.type !== 'application/json') return;

  var wrap = dataEl.previousElementSibling;
  if (!wrap || !wrap.hasAttribute('data-breadcrumb-fallback')) return;

  var ref = document.referrer;
  if (!ref) return;

  var data;
  try {
    data = JSON.parse(dataEl.textContent);
  } catch (e) {
    return;
  }

  var host = data.host;
  var collections = data.collections || {};

  function normalizeHost(hostname) {
    return hostname.replace(/^www\./, '');
  }

  try {
    var refUrl = new URL(ref);
    var refHost = normalizeHost(refUrl.hostname);
    var siteHost = normalizeHost(host);
    if (refHost !== siteHost && !refHost.endsWith('.' + siteHost)) return;
    var match = refUrl.pathname.match(/\/collections\/([^/]+)/);
    if (!match) return;
    var col = collections[match[1]];
    if (!col) return;
    var btn = wrap.querySelector('.product-breadcrumbs__link--history');
    if (!btn) return;
    var link = document.createElement('a');
    link.href = col.url;
    link.title = col.text;
    link.className = btn.className.replace(' product-breadcrumbs__link--history', '');
    link.innerHTML = btn.innerHTML;
    var textEl = link.querySelector('.product-breadcrumbs__link-text');
    if (textEl) textEl.textContent = col.text;
    link.removeAttribute('onclick');
    wrap.replaceChild(link, btn);
  } catch (e) {}
})();
